// Holds "a new version of the app has been deployed" state, set by the
// service-worker wiring in main.js and read by navigation-drawer.vue's
// Update button.
const state = {
  updateAvailable: false,
  waitingWorker: null,
};

const getters = {
  updateAvailable: (s) => s.updateAvailable,
};

const mutations = {
  SET_UPDATE_AVAILABLE(state, worker) {
    state.updateAvailable = true;
    state.waitingWorker = worker;
  },
};

const actions = {
  applyUpdate({ state }) {
    if (!state.waitingWorker) {
      // No waiting worker reference (e.g. detected via a fresh
      // registration lookup) — a plain reload still picks up the new
      // version once the new SW has finished installing.
      window.location.reload();
      return;
    }

    // Ask the waiting worker to activate, then reload once it does so
    // the reload is guaranteed to be served by the new version.
    navigator.serviceWorker.addEventListener(
      'controllerchange',
      () => window.location.reload(),
      { once: true },
    );
    state.waitingWorker.postMessage('SKIP_WAITING');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
